import { ApiCaller } from '../../utils/api'
import { URLS } from '../../utils/url'
import { Message } from "element-ui";

const state = {
  dataRepeatCharts:{num_repeats: [], percent_repeats: [], customer_visited: '', repeat_rate: '', average_price: '', genders: [], timeprice_data: [], area_data: [] },
  repeat_chart: {
    num_repeats: [],
    percent_repeats: [],
    isLoading: true
  },
  gender_chart: {
    genders: [],
    isLoading: true
  },
  timeprice_chart: {
    timeprice_data: [],
    isLoading: true
  },
  area_chart: {
    area_data: {
      labels: [],
      data: []
    },
    isLoading: true
  },
  customerVisted: '',
  averagePrice: '',
  repeatRate: ''
}
const mutations = {
  set_repeat_chart(state, payload) {
    state.repeat_chart.num_repeats = payload.num_repeats
    state.repeat_chart.percent_repeats = payload.percent_repeats
    state.repeat_chart.isLoading = false
  },
  set_gender_chart(state, payload) {
    state.gender_chart.genders = payload.genders
    state.gender_chart.isLoading = false
  },
  set_timeprice_chart(state, payload) {
    state.timeprice_chart.timeprice_data = payload.timeprice_data
    state.timeprice_chart.isLoading = false
  },
  set_area_chart(state, payload) {
    state.area_chart.area_data = payload.area_data
    state.area_chart.isLoading = false
  },
  set_something_else(state, payload) {
    state.customerVisted = payload['customer_visited']
    state.averagePrice = payload['average_price']
    state.repeatRate = payload['repeat_rate']
  },
  set_show_loading(state, payload) {
    state.repeat_chart.isLoading = true
    state.gender_chart.isLoading = true
    state.timeprice_chart.isLoading = true
    state.area_chart.isLoading = true
  }
}
const actions = {
  async fetchDataAnalytics({state, commit}, payload) {
    commit('set_show_loading', true)
    const res = await ApiCaller().get(URLS.DATA_ANALYTICS(), {params: payload})
    if (res.status == 200) {
      commit(`set_${payload['context']}`, res.data.data.data_analytics)
      commit('common/SET_START_WEEEKDAY', res.data.data.start_weekday, { root: true })
    }
  }
}
export default {
  namespaced: true,
  state, mutations, actions
}
